module.exports = __webpack_public_path__ + "img/interview_with_somoy_tv.4b18facc.jpg";